import {GoogleMap, InfoWindow, LoadScriptNext, Marker, MarkerClusterer} from '@react-google-maps/api';
import {Accordion, AccordionTab} from 'primereact/accordion';
import {Dialog} from 'primereact/dialog';
import React from 'react';
import {Card} from 'react-bootstrap';
import Geocode from 'react-geocode';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import ActionButton from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import {CustomMessages} from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import InputMultiCheckboxComponent from '../components/inputs/InputMultiCheckboxComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import SettingService from '../services/SettingService';
import StationsMapService from '../services/StationsMapService';
import InputSelectButtonComponent from '../components/inputs/InputSelectButtonComponent';
import MapFilterContainer from "./MapFilterContainer";
import CustomDialog from '../components/CustomDialog';
import ProfileService from '../services/ProfileService';
const oms = require(`npm-overlapping-marker-spiderfier/lib/oms.min`);

let clusterStylesBlue = [
    {
        height: 60,
        textColor: '#ffffff',
        width: 60,
        fontWeight: 'normal',
        className: 'iconStyleClassName1',
        url: 'data:image/svg+xml;charset=UTF-8,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" height="60" width="60"%3E%3Ccircle cx="30" cy="30" r="15"  fill="%233059e8" /%3E%3C/svg%3E',
    },
];

let clusterStylesGreen = [
    {
        height:60,
        textColor: '#ffffff',
        width: 60,
        fontWeight: 'normal',
        className: 'iconStyleClassName2',
        url: 'data:image/svg+xml;charset=UTF-8,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" height="60" width="60"%3E%3Ccircle cx="30" cy="30" r="15" stroke="white" stroke-width="6" fill="%231ab759"  /%3E%3C/svg%3E'
    },
];
class StationsMapContainer extends BaseContainer {
    constructor(props) {
        super(props, new StationsMapService());
        const {t} = this.props;
        this.settingService = new SettingService();
        this.profileService = new ProfileService();
        this.user = this.authService.getProfile();
        this.renderCriteria = this.renderCriteria.bind(this);
        this.renderChargingStationCriteria = this.renderChargingStationCriteria.bind(this);
        this.cleanSearchCriteria = this.cleanSearchCriteria.bind(this);
        this.setFilterCounter = this.setFilterCounter.bind(this);
        this.cleanSearchCriteria = this.cleanSearchCriteria.bind(this);
        this.chargingStationCleanSearchCriteria = this.chargingStationCleanSearchCriteria.bind(this);
        this.getList = this.getList.bind(this);
        this.getChargingStationList = this.getChargingStationList.bind(this);
        this.handleMapModeChange = this.handleMapModeChange.bind(this);
        this.renderMarkerInfo = this.renderMarkerInfo.bind(this);
        this.renderNavigateButton = this.renderNavigateButton.bind(this);
        this.renderOpeningTimes = this.renderOpeningTimes.bind(this);
        this.renderChargingStationOpeningTimes = this.renderChargingStationOpeningTimes.bind(this);
        this.renderChargingStationOpeningShopTimes = this.renderChargingStationOpeningShopTimes.bind(this);
        this.geocodeAdress = this.geocodeAdress.bind(this);
        this.openInfoWindow = this.openInfoWindow.bind(this);
        this.openChargingStationInfoWindow = this.openChargingStationInfoWindow.bind(this);
        this.closeInfoWindow = this.closeInfoWindow.bind(this);
        this.handleLoad = this.handleLoad.bind(this);
        this.handleChargingStationFormSubmit = this.handleChargingStationFormSubmit.bind(this);
        this.clustererRef = React.createRef();
        this.state = {
            dialogVisible: false,
            rerenderFlag: false,
            loading: null,
            activeIndex: [],
            filterCount: 0,
            addedMarkers: [],
            clustersStyle: clusterStylesBlue,

            stationTypeOptions: [
                {
                    enumValue: 'ATTENDED',
                    label: t('StationType.ATTENDED'),
                    image: <img src='/images/ico_moya_logo_blue.svg' alt={t('stationsMap.stationTypeBlue')} />,
                },
                {
                    enumValue: 'AUTO_FLEET',
                    label: t('StationType.AUTO_FLEET'),
                    image: <img src='/images/ico_moya_logo_black.svg' alt={t('stationsMap.stationTypeBlack')} />,
                },
                {
                    enumValue: 'EXPRESS',
                    label: t('StationType.EXPRESS'),
                    image: <img src='/images/ico_moya_logo_red.svg' alt={t('stationsMap.stationTypeRed')} />,
                },
            ],
            portTypeOptions: [
                {
                    enumValue: 'TYPE_2',
                    label: t('PortType.TYPE_2'),
                    image: <img src='/images/ico_port_type_2.svg' alt={t('stationsMap.portType2')} />,
                },
                {
                    enumValue: 'CCS',
                    label: t('PortType.CCS'),
                    image: <img src='/images/ico_port_ccs.svg' alt={t('stationsMap.portCcs')} />,
                },
                {
                    enumValue: 'CHADEMO',
                    label: t('PortType.CHADEMO'),
                    image: <img src='/images/ico_port_chademo.svg' alt={t('stationsMap.portChademo')} />,
                },
            ],
            chargingPowerOptions: [
                {
                    enumValue: '11',
                    label: t('ChargingPower.11_KW'),
                },
                {
                    enumValue: '22',
                    label: t('ChargingPower.22_KW'),
                },
                {
                    enumValue: '43',
                    label: t('ChargingPower.43_KW'),
                },
                {
                    enumValue: '50+',
                    label: t('ChargingPower.50_PLUS_KW'),
                },
                {
                    enumValue: '100+',
                    label: t('ChargingPower.100_PLUS_KW'),
                },
                {
                    enumValue: '150+',
                    label: t('ChargingPower.150_PLUS_KW'),
                },
            ],
            facilitiesOptions: [
                /*  {
                    enumValue: 'HOTEL',
                    label: t('stationsMap.HOTEL'),
                },
                {
                    enumValue: 'RESTAURANT',
                    label: t('stationsMap.RESTAURANT'),
                },
                {
                    enumValue: 'CAFE',
                    label: t('stationsMap.CAFE'),
                },
                {
                    enumValue: 'MALL',
                    label: t('stationsMap.MALL'),
                },
                {
                    enumValue: 'SUPERMARKET',
                    label: t('stationsMap.SUPERMARKET'),
                },
                {
                    enumValue: 'SPORT',
                    label: t('stationsMap.SPORT'),
                },
                {
                    enumValue: 'RECREATION_AREA',
                    label: t('stationsMap.RECREATION_AREA'),
                },
                {
                    enumValue: 'NATURE',
                    label: t('stationsMap.NATURE'),
                },
                {
                    enumValue: 'MUSEUM',
                    label: t('stationsMap.MUSEUM'),
                },
                {
                    enumValue: 'BIKE_SHARING',
                    label: t('stationsMap.BIKE_SHARING'),
                },
                {
                    enumValue: 'BUS_STOP',
                    label: t('stationsMap.BUS_STOP'),
                },
                {
                    enumValue: 'TAXI_STAND',
                    label: t('stationsMap.TAXI_STAND'),
                },
                {
                    enumValue: 'TRAM_STOP',
                    label: t('stationsMap.TRAM_STOP'),
                },
                {
                    enumValue: 'METRO_STATION',
                    label: t('stationsMap.METRO_STATION'),
                },
                {
                    enumValue: 'TRAIN_STATION',
                    label: t('stationsMap.TRAIN_STATION'),
                },
                {
                    enumValue: 'AIRPORT',
                    label: t('stationsMap.AIRPORT'),
                },
                {
                    enumValue: 'PARKING_LOT',
                    label: t('stationsMap.PARKING_LOT'),
                },
                {
                    enumValue: 'CARPOOL_PARKING',
                    label: t('stationsMap.CARPOOL_PARKING'),
                },
                {
                    enumValue: 'FUEL_STATION',
                    label: t('stationsMap.FUEL_STATION'),
                },
                {
                    enumValue: 'WIFI',
                    label: t('stationsMap.WIFI'),
                }, */
            ],
            fuelTypeOptions: [],
            serviceTypeOptions: [],
            infoWindowId: undefined,
            chargingStationInfoWindowId: undefined,
            mapRef: undefined,
            evInfoWindowRef: undefined,
            spiderfierMarkerOpen: false,
            criteria: this.getCleanSearchCriteria(),
            chargingStationCriteria: this.getChargingStationCleanSearchCriteria(),
            location: '',
            geocodeLocation: undefined,
            defaultCenter: {
                lat: 52.112795,
                lng: 19.211946,
            },
            zoom: 6,
            currentCenter: undefined,
            googleMapsApiKey: undefined,
            mapMode: {
                label: 'Stacje paliw',
                enumValue: 'PETROL',
            },
            mapModeOptions: [
                {
                    label: 'Stacje paliw',
                    enumValue: 'PETROL',
                },
                {
                    label: 'Stacje ładowania',
                    enumValue: 'ELECTRIC',
                },
            ],
        };
    }
    
    componentDidUpdate(){
        super.componentDidUpdate();
     
        this.clustererRef.current?.repaint();
        }

    componentDidMount() {
        const {t} = this.props;
        super.componentDidMount();
        {this.checkIfDeviceAlreadyAddedToTrusted()}
        this.blockUi();
        this.service
            .getCriteriaOptions('stationsMap', t)
            .then((ProductType) => {
                this.setState({
                    // stationTypeOptions: ProductType?.stationTypeOptions,
                    fuelTypeOptions: ProductType?.fuelTypeOptions,
                    serviceTypeOptions: ProductType.serviceTypeOptions,
                });
            })
            .then(this.refreshTable())
            .catch(() => {
                this.showErrorMessage(t('error.typeListError'));
                this.unblockUi();
            });
        this.enumService
            .getEnumList('ChargingStationCapabilityType', t)
            .then((capabilitiesTypeOptions) => {
                this.setState({
                    capabilitiesTypeOptions,
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.statusListError'));
            });

        this.settingService
            .getValue('GOOGLE_MAPS_API_KEY_UI')
            .then((resp) => {
                this.setState(
                    {
                        googleMapsApiKey: resp.value,
                    },
                    () => Geocode.setApiKey(this.state.googleMapsApiKey)
                );
            })
            .catch((e) => this.showErrorMessage(t('stationsMap.getAPIerror')));
    }

    onAfterGetList() {
        this.unblockUi();
        this.setState({
            rerenderFlag : true,
            
        })
    }

    refreshTable() {
        this.getList();
    }

    updateListElements(list) {
        return list;
    }

    getList() {
        const {criteria} = this.state;

        this.blockUi();
        this.service
            .getList(criteria)
            .then((data) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            list: this.updateListElements(data),
                            loading: false,
                            size: 0,
                           
                        },
                        () => this.onAfterGetList()
                    );
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            list: [],
                            loading: false,
                            
                            size: 0,
                            clusterStyle: [],
                            addedMarkers: [],
                        },
                        () => this.afterGetListError()
                    );
                }
            });
    }
    checkIfDeviceAlreadyAddedToTrusted() {
        const { t } = this.props;
        if(this.readCookie('startAfterLoginCookie') === 'true' && !(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
        this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
        this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
        this.authService.getProfile().helpdeskUserRole === 'HOTLINE')){
            let currentDeviceIdent = this.authService.generateDeviceUuid();
            this.profileService.getTrustedDevices(this.user?.userAgreementMapId)
                .then((res) => {
                    if (res.trustedDeviceList.length > 0) {
                        if(res.trustedDeviceList.filter(d => d.deviceIdent === currentDeviceIdent).length > 0) {
                            console.log("Urzadzenie to jest na liście zaufanych. ")
                            this.setState({ addTrustedDeviceDialog: false });
                        }
                        else {
                            console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                            this.setState({ addTrustedDeviceDialog: true });
                        }
                    }  else {console.log("Urzadzenie to nie widnieje na liście zaufanych. ")
                        this.setState({ addTrustedDeviceDialog: true });}
                })
                .catch(() => {
                    this.showErrorMessage(t('error.profileTrustedDevicesError'));
                })
        }
       
    }

    handleAddToTrustedDevice() {
        let generatedDeviceUuid = this.authService.generateDeviceUuid();
        this.profileService
            .addTrustedDevice(generatedDeviceUuid, this.user?.userAgreementMapId)
            .then((res) => {
                if (res === true) {
                    this.showSuccessMessage("Dodano urządzenie do zaufanych");
                    this.saveCookie('startAfterLoginCookie', false);
                    this.setState({ addTrustedDeviceDialog: false });
                }
            })
            .catch(() => {
                this.showErrorMessage("Nie udało się dodać urządzenia do zaufanych");
            });
    }

    renderAddToTrustedDevicesDialog(){
        let startAfterLoginCookie = false;
        if (!(this.authService.getProfile().helpdeskUserRole === 'HELPDESK' ||
            this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER' ||
            this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' ||
            this.authService.getProfile().helpdeskUserRole === 'HOTLINE') &&
            this.readCookie('startAfterLoginCookie') === 'true') {
            startAfterLoginCookie = true;
        }
        return  (
            this.state.addTrustedDeviceDialog && startAfterLoginCookie === true) && <CustomDialog
            name='add-trusted-dialog'
            className='add-trusted-device'
            header="Dodawanie urządzenia do zaufanych"
            visible={this.state.addTrustedDeviceDialog}
            viewMode={'VIEW'}
            onHide={() => {
                //  this.authService.logout();
                this.saveCookie('startAfterLoginCookie', false);
                this.setState({
                    addTrustedDeviceDialog: false,
                    //renderCodeVerificationPage: true
                    //user: undefined,
                });
            }}
            closeable
        >
            <div className='codeDialog-text'>
                <label>{"W przypadku dodania urządzenia do zaufanych podawanie kodu weryfikacyjnego przy kolejnych logowaniach nie będzie wymagane."} </label>
            </div>
            <div className='col-width-auto codeBtn'>
                <ActionButton
                    label={"Dodaj"}
                    variant='blue'
                    // className='edit-blue-link'
                    handleClick={() => this.handleAddToTrustedDevice()}
                    disabled={this.state.captchaPreventAction}
                />
            </div>

        </CustomDialog>
    }

    getChargingStationList() {
        const {chargingStationCriteria} = this.state;
        this.blockUi();
        this.service
            .getChargingStationList(chargingStationCriteria)
            .then((data) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            list: this.updateListElements(data),
                            rerenderFlag: false,
                            loading: false,
                            size: 0,                       
                        },
                        () => this.onAfterGetList()
                    );
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            list: [],
                            loading: false,
                            size: 0,
                            addedMarkers: [],
                        },
                        () => this.afterGetListError()
                    );
                }
            });
    }

    afterGetListError() {
        this.showErrorMessage('Wystąpił błąd systemu. Nie udało się pobrać listy.');
        this.unblockUi();
    }

    updateSearchCriteria(criteria) {
        return {
            stationTypeList: criteria.stationTypeList,
            fuelList: criteria.fuelList,
            serviceList: criteria.serviceList,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    updateChargingStationSearchCriteria(criteria) {
        return {
            portTypeList: criteria.portTypeList,
            chargingPowerList: criteria.chargingPowerList,
            capabilityList: criteria.capabilityList,
        };
    }

    getCleanSearchCriteria() {
        return {
            stationTypeList: [],
            fuelList: [],
            serviceList: [],
            id: null,
            firstResult: 0,
            maxResults: 2147483647,
            sortField: 'id',
            sortAsc: false,
        };
    }

    getChargingStationCleanSearchCriteria() {
        return {
            portTypeList: [],
            chargingPowerList: [],
            capabilityList: [],
            id: null,
            firstResult: 0,
            maxResults: 2147483647,
            sortField: 'id',
            sortAsc: false,
        };
    }

    chargingStationCleanSearchCriteria() {
        this.setState({chargingStationCriteria: this.getChargingStationCleanSearchCriteria(), activeIndex: []});
    }

    cleanSearchCriteria() {
        this.setState({criteria: this.getCleanSearchCriteria(), activeIndex: []});
    }

    setFilterCounter() {
        const {criteria} = this.state;
        let filterCounter = criteria?.stationTypeList.length + criteria?.fuelList.length + criteria?.serviceList.length;
        return filterCounter;
    }

    setChargingStationFilterCounter() {
        const {chargingStationCriteria} = this.state;
        let filterCounter =
            chargingStationCriteria?.portTypeList.length +
            chargingStationCriteria?.chargingPowerList.length +
            chargingStationCriteria?.capabilityList.length;
        return filterCounter;
    }

    handleValidForm() {
        this.refreshTable();
    }

    renderMarkerInfo() {
        const {t} = this.props;
        const {station} = this.state;
        return station ? (
            <div className='row google-info-window'>
                <span className='city'>{station?.city}</span>
                <span className='address'>{`${station?.street} ${station?.streetNumber}`}</span>
                <span className='opening-times row'>{this.renderOpeningTimes(station?.openingTimes)}</span>
                <span className='row labels'>
                    {station?.fuels.map((fuel, index) => {
                        return (
                            <label key={`fuel-${index}`} className='info-marker-label' style={{color: 'white', background: fuel.color}}>
                                {t(`stationsMap.${fuel.productType}`)}
                            </label>
                        );
                    })}
                </span>
                <span className='row labels'>
                    {station?.services.map((service, index) => {
                        return (
                            <label key={`service-${index}`} className='info-marker-service-label info-marker-label'>
                                <img
                                    className='product-checkbox'
                                    src='/images/ico_product_checkbox.svg'
                                    alt={t('stationsMap.productCheckbox')}
                                />
                                {t(`stationsMap.${service.productType}`)}
                            </label>
                        );
                    })}
                </span>
                <span className='google-info-window-button'>{this.renderNavigateButton()}</span>
            </div>
        ) : null;
    }

    renderChargingPortStandard(standard) {
        const {t} = this.props;
        let standardImageSrc;
        let label;

        switch (standard) {
            case 'CCS':
                standardImageSrc = '/images/ico_port_ccs.svg';
                label = t('PortType.CCS');
                break;
            case 'TYPE_2':
                standardImageSrc = '/images/ico_port_type_2.svg';
                label = t('PortType.TYPE_2');
                break;
            case 'CHADEMO':
                standardImageSrc = '/images/ico_port_chademo.svg';
                label = t('PortType.CHADEMO');
                break;
            default:
                return <span className='port-standard-no-padding'>{standard}</span>;
        }

        return (
            <div>
                <img src={standardImageSrc} alt={standard} />
                <span className='port-standard'>{label}</span>
            </div>
        );
    }

    renderChargingStationMarkerInfo() {
      
        const {t} = this.props;
        const {station} = this.state;
        return station ? (
            <div className='row google-info-window'>
                <span className='city'>{station?.city}</span>
                <span className='address'>{station?.address}</span>
                <span className='charging-station-header'>{t(`stationsMap.chargingStationHeader`)}</span>
                <span className='opening-times row'>{this.renderChargingStationOpeningTimes(station?.openingTimes)}</span>
                <span className='charging-station-header'>{'Sklep'}</span>
                <span className='opening-times-shop row'>{this.renderChargingStationOpeningShopTimes(station?.xeeloOpeningTimes)}</span>
                <div className='charging-port-header-row'>
                    <span className='charging-station-header'>{t(`stationsMap.chargingPortsHeader`)}</span>
                    <div className='charging-port-number-container'>
                        <span className='charging-port-number'>{station.ports.length}</span>
                    </div>
                </div>
                {station?.ports.map((port, index) => {
                    return (
                        <div className='port-row'>
                            {this.renderChargingPortStandard(port.standard)}
                            <span className='port-charging-power'>{port.chargingPower + ' kW'}</span>
                            <div className='port-col'>
                                <span className='port-number'>{t(`stationsMap.connector`) + port.portNumber}</span>
                                <span className='port-number'>
                                    {port.withCable ? t(`stationsMap.withCable`) : t(`stationsMap.withoutCable`)}
                                </span>
                            </div>
                        </div>
                    );
                })}
                <span className='row labels'>
                    {station?.facilities.map((facility, index) => {
                        return (
                            <label key={`facility-${index}`} className='info-marker-service-label info-marker-label'>
                                <img
                                    className='product-checkbox'
                                    src='/images/ico_product_checkbox.svg'
                                    alt={t('stationsMap.productCheckbox')}
                                />
                                {t(`stationsMap.${facility}`)}
                            </label>
                        );
                    })}
                </span>
                <span className='google-info-window-button'>{this.renderNavigateButton()}</span>
            </div>
        ) : null;
    }

    renderNavigateButton() {
        const {t} = this.props;
        const {station} = this.state;
        return (
            <ActionButton
                label={t('stationsMap.navigateToStation')}
                variant='button blue button-navigate'
                colClass='col-md-2'
                iconSvg='ico_map_navigate_arrow_white'
                //iconSvg='stationNavigationButton'
                iconSide='left'
                //className='edit-blue-link under-table-button-left-icon'
                iconSize=''
                openInNewTab
                href={`https://www.google.com/maps/dir/?api=1&destination=${station?.latitude},${station?.longitude}`}
            />
        );
    }

    /* <ActionLink
            // label={`${t('cards.orderPlasticCard')} ${
            //     this.state.orderPlasticCardPrice
            // } ${t('currency.pln')}`}
            //label={`${t('cards.orderPlasticCard')}`}
            //handleClick={this.handleOrderPlasticConfirmationOpen}
            href={`https://www.google.com/maps/dir/?api=1&destination=${station?.latitude},${station?.longitude}`}
            variant='button blue button-navigate'
            // iconSize='icon-svg'
            //className='edit-blue-link under-table-button-left-icon'
            colClass='col-md-2'
            key={'view-button'}
           // iconSide='left'
            iconSvg='stationNavigationButton'
        /> */

    renderClearLink() {
        const {t} = this.props;
        return (
            <ActionLink
                label={t('list.clearFilters')}
                className='clear-filter-link'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    this.cleanSearchCriteria();
                    this.handleFormSubmit();
                }}
            />
        );
    }

    renderChargingStationClearLink() {
        const {t} = this.props;
        return (
            <ActionLink
                label={t('list.clearFilters')}
                className='clear-filter-link'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    this.chargingStationCleanSearchCriteria();
                    this.handleChargingStationFormSubmit();
                }}
            />
        );
    }

    renderSubmitButton() {
        const {t} = this.props;
        return (
            <ActionButton
                label={t('list.approve')}
                variant='button blue button-submit'
                colClass='col-md-2'
                iconSvg='ico_right_arrow_white'
                iconSide='left'
                iconSize=''
                handleClick={(e) => {
                    e.preventDefault();
                    this.handleFormSubmit();
                    this.setState({dialogVisible: false});
                }}
            />
        );
    }
    renderChargingCriteriaSubmitButton() {
        const {t} = this.props;
        return (
            <ActionButton
                label={t('list.approve')}
                variant='button blue button-submit'
                colClass='col-md-2'
                iconSvg='ico_right_arrow_white'
                iconSide='left'
                iconSize=''
                handleClick={(e) => {
                    e.preventDefault();
                    this.handleChargingStationFormSubmit();
                    this.setState({dialogVisible: false});
                }}
            />
        );
    }

    renderOpeningTimes(openingTimes) {
        const {t} = this.props;
        const render = openingTimes?.map((oTime, index) => {
            if (oTime.fromDay === oTime.toDay) {
                oTime.name = t(`stationsMap.${oTime.fromDay}`);
            } else {
                oTime.name = `${t(`stationsMap.${oTime.fromDay}`)}-${t(`stationsMap.${oTime.toDay}`)}`;
            }
            if (
                (oTime?.fromTime === '00:00' && oTime?.toTime === '23:59') ||
                (oTime?.fromTime === oTime?.toTime && oTime?.fromTime !== null)
            ) {
                oTime.time = t('stationsMap.24/7');
            } else if (oTime?.fromTime === null && oTime?.toTime === null) {
                oTime.time = t('stationsMap.closed');
            } else {
                oTime.time = `${oTime?.fromTime}-${oTime?.toTime}`;
            }
            return <span key={`opening-times-${index}`} className='col-12'>{`${oTime?.name} ${oTime?.time}`}</span>;
        });

        return render;
    }

    renderChargingStationOpeningTimes(openingTimes) {
        const {t} = this.props;
        if (openingTimes == null || openingTimes.twentyFourSeven) {
            const weekdays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
            const render = weekdays.map((day, index) => {
                return (
                    <span key={`opening-times-${index}`} className='col-12'>{`${t(`stationsMap.${day}`)} ${t('stationsMap.24/7')}`}</span>
                );
            });
            return render;
        } else if (openingTimes.regularHours !== null) {
            const render = openingTimes?.regularHours?.map((oTime, index) => {
                oTime.name = t(`stationsMap.${oTime.day}`);
                if (
                    (oTime?.fromTime === '00:00' && oTime?.toTime === '23:59') ||
                    (oTime?.fromTime === oTime?.toTime && oTime?.fromTime !== null)
                ) {
                    oTime.time = t('stationsMap.24/7');
                } else if (oTime?.fromTime === null && oTime?.toTime === null) {
                    oTime.time = t('stationsMap.closed');
                } else {
                    oTime.time = `${oTime?.fromTime}-${oTime?.toTime}`;
                }
                return <span key={`opening-times-${index}`} className='col-12'>{`${oTime?.name} ${oTime?.time}`}</span>;
            });
            return render;
        }
    }
    mapDayIntToString(day) {
        switch (day) {
            case 1:
                return 'MONDAY';
            case 2:
                return 'TUESDAY';
            case 3:
                return 'WEDNESDAY';
            case 4:
                return 'THURSDAY';
            case 5:
                return 'FRIDAY';
            case 6:
                return 'SATURDAY';
            case 7:
                return 'SUNDAY';
            default:
                return day;
        }
    }
    renderChargingStationOpeningShopTimes(shopOpeningTimes) {
        shopOpeningTimes.forEach((m) => {
            m.day = this.mapDayIntToString(m.day);
        });

        const {t} = this.props;
        if (shopOpeningTimes == null || shopOpeningTimes.twentyFourSeven) {
            const weekdays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
            const render = weekdays.map((day, index) => {
                return (
                    <span key={`opening-times-shop-${index}`} className='col-12'>{`${t(`stationsMap.${this.mapDayIntToString(day)}`)} ${t(
                        'stationsMap.24/7'
                    )}`}</span>
                );
            });
            return render;
        } else if (shopOpeningTimes !== null) {
            const render = shopOpeningTimes?.map((oTime, index) => {
                oTime.name = t(`stationsMap.${oTime.day}`);
                if (
                    (oTime?.fromTime === '00:00' && oTime?.toTime === '23:59') ||
                    (oTime?.fromTime === oTime?.toTime && oTime?.fromTime !== null)
                ) {
                    oTime.time = t('stationsMap.24/7');
                } else if (oTime?.fromTime === null && oTime?.toTime === null) {
                    oTime.time = t('stationsMap.closed');
                } else {
                    oTime.time = `${oTime?.fromTime}-${oTime?.toTime}`;
                }
                return <span key={`opening-times-shop-${index}`} className='col-12'>{`${oTime?.name} ${oTime?.time}`}</span>;
            });
            return render;
        }
    }

    geocodeAdress() {
        const {t} = this.props;
        const {location, geocodeLocation, mapRef} = this.state;
        if (location && location !== '') {
            if (geocodeLocation?.place !== location) {
                this.service
                    .geocode(location)
                    .then((response) => {
                        try {
                            if (response != null && response.length !== 0 && response[0].geometry != null) {
                                this.setState((prevState) => ({
                                    ...prevState,
                                    zoom: 15,
                                    geocodeLocation: {
                                        place: location,
                                        locationCoordinates: response[0].geometry.location,
                                    },
                                }), () => {
                                    if (this.state.mapRef !== null)
                                        this.state.mapRef.setZoom(15);
                                });
                            } else {
                                this.showErrorMessage(t('error.getGeocodeError'));
                            }
                        } catch (e) {
                            this.showErrorMessage(t('error.getGeocodeError'))
                        } finally {
                            this.unblockUi();
                        }
                    })
                    .catch(() => this.showErrorMessage(t('error.getGeocodeError')))
                    .finally(() => {
                        this.unblockUi();
                    });
                // Geocode.fromAddress(location).then((response) => {
                //     console.log('Geocode.fromAddress', response);
                //     const locationCoordinates = response.results[0].geometry.location;
                //     this.setState((prevState) => ({
                //         ...prevState,
                //         zoom: 12,
                //         geocodeLocation: {
                //             place: location,
                //             locationCoordinates,
                //         },
                //     }));
                // });
            } else {
                try {
                    mapRef.setCenter(geocodeLocation?.locationCoordinates);
                }finally {
                    this.unblockUi();
                }
            }
        }else{
            this.unblockUi();
        }
    }

    openInfoWindow(markerId) {
        const {station} = this.state;
        if (markerId !== station?.siteId) {
            const {t} = this.props;
            this.service
                .getStationById(markerId)
                .then((station) => {
                    this.setState({
                        station,
                        infoWindowId: markerId,
                    });
                    this.unblockUi();
                })
                .catch(() => {
                    this.setState({
                        station: undefined,
                    });
                    this.showErrorMessage(t('error.getStationsError'));
                    this.unblockUi();
                });
        }
    }

    openChargingStationInfoWindow(markerId) {      
        const {station} = this.state;
        if (markerId !== station?.locationId) {
            const {t} = this.props;
            this.service
                .getChargingStationById(markerId)
                .then((station) => {
                    this.setState({
                        station,
                        chargingStationInfoWindowId: markerId,
                    });
                    this.unblockUi();
                })
                .catch(() => {
                    this.setState({
                        station: undefined,
                    });
                    this.showErrorMessage(t('error.getStationsError'));
                    this.unblockUi();
                });
        }
    }

    closeInfoWindow() {
        this.setState({
            infoWindowId: undefined,
            station: undefined,
        });
    }

    closeChargingStationInfoWindow() {
        this.setState({
            chargingStationInfoWindowId: undefined,
            station: undefined,
            addedMarkers:[],
            spiderfierMarkerOpen: false,
        });
    }

    handleLoad(map) {
        const newOms = new oms.OverlappingMarkerSpiderfier(map, {
            markersWontMove: false,
            markersWontHide: false,
            basicFormatEvents: false,
            spiderfiedShadowColor: false,
            lineToCenter: false,
            legWeight: 0,
        });
        map.addListener('zoom_changed', ()=>{
            if(this.state.evInfoWindowRef){
                this.state.evInfoWindowRef.close();
            }
        });
        this.setState({
            mapRef: map,
            currentCenter: map?.getCenter(),
            oms: newOms
        });
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            this.closeInfoWindow();
            this.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    handleChargingStationFormSubmit(event) {
        this.getChargingStationList();
    }

    hideDialog() {
        this.setState({dialogVisible: false});
    }

    render() {
        const {t} = this.props;
        return (
            <DivContainer colClass='container-fluid stations-map-container'>
                <DivContainer colClass='dashboard'>
                    <BlockUi
                        tag='div'
                        blocking={this.state.blocking || this.state.loading}
                        loader={this.loader}
                        rendered={!this.props.embedded}
                    >
                        <Dialog
                            ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                            header={`${t('list.filter')}`}
                            visible={this.state.dialogVisible}
                            className={'stations-map-criteria-dialog'}
                            key={'aaaa'}
                            onHide={() => this.hideDialog()}
                            closable={true}
                            modal={true}
                            blockScroll
                        >
                            <Card> {this.state.mapMode.enumValue === 'PETROL' ? this.renderCriteria() : this.renderChargingStationCriteria()}</Card>
                            <div className='stations-map-dialog-buttons'>
                                {this.state.mapMode.enumValue === 'PETROL' ? this.renderClearLink(): this.renderChargingStationClearLink()} 
                                {this.state.mapMode.enumValue === 'PETROL' ? this.renderSubmitButton() : this.renderChargingCriteriaSubmitButton()}
                            </div>
                        </Dialog>
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                        {this.renderAddToTrustedDevicesDialog()}
                        {this.renderDetails()}
                    </BlockUi>
                </DivContainer>
            </DivContainer>
        );
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    handleMapModeChange(a, b, c, d, e) {
        if (c.value !== null) {
            if (this.state.mapMode.enumValue === 'ELECTRIC') {
                this.setState(
                    {
                        list: [],
                        addedMarkers: [],
                        mapMode: {
                            label: 'Stacje paliw',
                            enumValue: 'PETROL',
                        },
                        clustersStyle: clusterStylesBlue,
                        rerenderFlag: false,
                    },
                    () => {this.closeInfoWindow();
                            this.getList()}
                );
            }
            if (this.state.mapMode.enumValue === 'PETROL') {
                this.setState(
                    {
                        list: [],
                        addedMarkers: [],
                        mapMode: {
                            label: 'Stacje ładowania',
                            enumValue: 'ELECTRIC',
                        },
                        clustersStyle: clusterStylesGreen,
                        rerenderFlag: false,
                    },
                    () => {this.closeInfoWindow();
                        this.getChargingStationList()}
                );
            }
        }
    }

    renderCriteria() {
        const {t} = this.props;
        const {stationTypeOptions, fuelTypeOptions, serviceTypeOptions, activeIndex} = this.state;
        const {stationTypeList, fuelList, serviceList} = this.state.criteria;
        return (
            <div className='p-card'>
                <div className='row'>
                    <div className='filter-header'>
                        <div className='filter-header-text'>
                            <img className='card-icon' alt={t('list.filter')} src={`/images/ico_filter.svg`} />
                            <span className='filter-header-text'>{`${t('list.filter')} (${this.setFilterCounter()})`}</span>
                        </div>
                        {this.renderClearLink()}
                    </div>
                    <Accordion multiple={true} activeIndex={activeIndex}>
                        <AccordionTab header={t('stationsMap.criteriaStationType')}>
                            <InputMultiCheckboxComponent
                                colClass='col-12'
                                id='stationTypeList'
                                label='stationTypeList'
                                showLabel={false}
                                name='stationTypeList'
                                onChange={this.handleChange}
                                validator={this.validator}
                                validators=''
                                onAfterStateChange={this.state.dialogVisible ? () => {} : this.handleFormSubmit}
                                options={stationTypeOptions}
                                selectedItemsLabel='vvv'
                                value={stationTypeList}
                                valueKey='enumValue'
                                valueLabel='label'
                                itemColClass={'col-12'}
                                viewMode='NEW'
                                labelOnRight
                                stateField='criteria'
                                showDescription
                                description='image'
                                descriptionClassName='station-type-image'
                            />
                        </AccordionTab>
                        <AccordionTab header={t('stationsMap.criteriaFuels')}>
                            <InputMultiCheckboxComponent
                                colClass='col-12'
                                id='fuelList'
                                label='fuelList'
                                showLabel={false}
                                name='fuelList'
                                onChange={this.handleChange}
                                validator={this.validator}
                                validators=''
                                onAfterStateChange={this.state.dialogVisible ? () => {} : this.handleFormSubmit}
                                options={fuelTypeOptions}
                                selectedItemsLabel='vvv'
                                value={fuelList}
                                valueKey='productType'
                                valueLabel='name'
                                valueLabelBackgroundColor='color'
                                itemColClass={'col-12'}
                                viewMode='NEW'
                                labelOnRight
                                stateField='criteria'
                            />
                        </AccordionTab>
                        <AccordionTab header={t('stationsMap.criteriaServices')}>
                            <InputMultiCheckboxComponent
                                colClass='col-12'
                                id='serviceList'
                                label='serviceList'
                                showLabel={false}
                                name='serviceList'
                                onChange={this.handleChange}
                                validator={this.validator}
                                validators=''
                                options={serviceTypeOptions}
                                onAfterStateChange={this.state.dialogVisible ? () => {} : this.handleFormSubmit}
                                selectedItemsLabel='vvv'
                                value={serviceList}
                                valueKey='productType'
                                valueLabel='name'
                                itemColClass={'col-12'}
                                viewMode='NEW'
                                labelOnRight
                                stateField='criteria'
                            />
                        </AccordionTab>
                    </Accordion>
                </div>
            </div>
        );
    }

    renderChargingStationCriteria() {
        const {t} = this.props;
        const {portTypeOptions, chargingPowerOptions, capabilitiesTypeOptions, activeIndex} = this.state;
        const {portTypeList, chargingPowerList, capabilityList} = this.state.chargingStationCriteria;
        return (
            <div className='p-card'>
                <div className='row'>
                    <div className='filter-header'>
                        <div className='filter-header-text'>
                            <img className='card-icon' alt={t('list.filter')} src={`/images/ico_filter.svg`} />
                            <span className='filter-header-text'>{`${t('list.filter')} (${this.setChargingStationFilterCounter()})`}</span>
                        </div>
                        {this.renderChargingStationClearLink()}
                    </div>
                    <Accordion multiple={true} activeIndex={activeIndex}>
                        <AccordionTab header={t('stationsMap.criteriaPortType')}>
                            <InputMultiCheckboxComponent
                                colClass='col-12'
                                id='portTypeList'
                                label='portTypeList'
                                showLabel={false}
                                name='portTypeList'
                                onChange={this.handleChange}
                                validator={this.validator}
                                validators=''
                                onAfterStateChange={this.state.dialogVisible ? () => {} : this.handleChargingStationFormSubmit}
                                options={portTypeOptions}
                                selectedItemsLabel='vvv'
                                value={portTypeList}
                                valueKey='enumValue'
                                valueLabel='label'
                                itemColClass={'col-12'}
                                viewMode='NEW'
                                labelOnRight
                                stateField='chargingStationCriteria'
                                showDescription
                                description='image'
                                descriptionClassName='station-type-image'
                            />
                        </AccordionTab>
                        <AccordionTab header={t('stationsMap.criteriaChargingPowers')}>
                            <InputMultiCheckboxComponent
                                colClass='col-12'
                                id='chargingPowerList'
                                label='chargingPowerList'
                                showLabel={false}
                                name='chargingPowerList'
                                onChange={this.handleChange}
                                validator={this.validator}
                                validators=''
                                options={chargingPowerOptions}
                                onAfterStateChange={this.state.dialogVisible ? () => {} : this.handleChargingStationFormSubmit}
                                selectedItemsLabel='vvv'
                                value={chargingPowerList}
                                valueKey='enumValue'
                                valueLabel='label'
                                itemColClass={'col-12'}
                                viewMode='NEW'
                                labelOnRight
                                stateField='chargingStationCriteria'
                            />
                        </AccordionTab>
                        <AccordionTab header={t('stationsMap.criteriaCapabilities')}>
                            <InputMultiCheckboxComponent
                                colClass='col-12'
                                id='capabilityList'
                                label='capabilityList'
                                showLabel={false}
                                name='capabilityList'
                                onChange={this.handleChange}
                                validator={this.validator}
                                validators=''
                                options={capabilitiesTypeOptions}
                                onAfterStateChange={this.state.dialogVisible ? () => {} : this.handleChargingStationFormSubmit}
                                selectedItemsLabel='vvv'
                                value={capabilityList}
                                valueKey='enumValue'
                                valueLabel='label'
                                itemColClass={'col-12'}
                                viewMode='NEW'
                                labelOnRight
                                stateField='chargingStationCriteria'
                            />
                        </AccordionTab>
                        {/* <AccordionTab header={t('stationsMap.criteriaFacilities')}>
                            <InputMultiCheckboxComponent
                                colClass='col-12'
                                id='facilityList'
                                label='facilityList'
                                showLabel={false}
                                name='facilityList'
                                onChange={this.handleChange}
                                validator={this.validator}
                                validators=''
                                options={facilitiesOptions}
                                onAfterStateChange={this.state.dialogVisible ? () => { } : this.handleChargingStationFormSubmit}
                                selectedItemsLabel='vvv'
                                value={facilityList}
                                valueKey='enumValue'
                                valueLabel='label'
                                itemColClass={'col-12'}
                                viewMode='NEW'
                                labelOnRight
                                stateField='chargingStationCriteria'
                            />
                        </AccordionTab> */}
                    </Accordion>
                </div>
            </div>
        );
    }

    renderDetails() {
        const itemTemplate = (option) => {
            if (option.enumValue === 'PETROL') {
                if (this.state.mapMode.enumValue === 'PETROL') {
                    return (
                        <div>
                            <img src='/images/ico_petrol_station_switch_selected.svg' alt={option.enumValue} />
                            <span className='petrol-switch-text-selected'>{option.label}</span>
                        </div>
                    );
                } else {
                    return (
                        <div>
                            <img src='/images/ico_petrol_station_switch.svg' alt={option.enumValue} />
                            <span className='petrol-switch-text'>{option.label}</span>
                        </div>
                    );
                }
            } else {
                if (this.state.mapMode.enumValue === 'ELECTRIC') {
                    return (
                        <div>
                            <img src='/images/ico_charging_station_switch_selected.svg' alt={option.enumValue} />
                            <span className='charging-switch-text-selected'>{option.label}</span>
                        </div>
                    );
                } else {
                    return (
                        <div>
                            <img src='/images/ico_charging_station_switch.svg' alt={option.enumValue} />
                            <span className='charging-switch-text'>{option.label}</span>
                        </div>
                    );
                }
            }
        };
        const {t} = this.props;

        const {
            location,
            geocodeLocation,
            currentCenter,
            defaultCenter,
            list,
            infoWindowId,
            googleMapsApiKey,
            chargingStationInfoWindowId,
            addedMarkers
        } = this.state;
        return (
            <div className='row stations-map'>
                <MapFilterContainer
                    onActionCallback={(locationTmp) => {
                        this.blockUi(()=>{
                            this.setState({location: locationTmp}, () => {
                                    this.geocodeAdress();
                            });
                        });
                    }}
                />
                <div className='col-md-2'>
                    <ActionButton
                        label={t('stationsMap.find')}
                        variant='button blue button-find stations-map-1024up'
                        colClass='col-md-2'
                        iconSvg='ico_right_arrow_white'
                        iconSide='left'
                        iconSize=''
                        handleClick={(e) => {
                            e.preventDefault();
                            if (location && location !== '') {
                                this.geocodeAdress();
                            }
                        }}
                    />
                </div>
                <div className='col-12'></div>
                <div className='row'>
                    <div className='col-md-4 stations-map-1024up'>
                        <div
                            className={
                                this.state.mapMode.enumValue === 'PETROL'
                                    ? 'stations-switch petrol-buttons-blue'
                                    : 'stations-switch charger-buttons-green'
                            }
                        >
                            <InputSelectButtonComponent
                                id='mapMode'
                                name='mapMode'
                                colClass='col-12'
                                value={this.state.mapMode}
                                options={this.state.mapModeOptions}
                                optionLabel='label'
                                optionValue='enumValue'
                                onChange={this.handleMapModeChange}
                                viewMode={'EDIT'}
                                stateField={''}
                                itemTemplate={itemTemplate}
                            />
                        </div>
                        {this.state.mapMode.enumValue === 'PETROL' ? this.renderCriteria() : this.renderChargingStationCriteria()}
                    </div>
                    <DivContainer colClass='col-md-8 '>
                        {googleMapsApiKey && googleMapsApiKey !== '' ? (
                            <div className='google-map-wrapper'>
                                <div className='row'>
                                    <div className='map-location-embedded'>
                                        <InputTextComponent
                                            id='location'
                                            name='location'
                                            label='location'
                                            showLabel={false}
                                            placeholder={t('stationsMap.enterLocation')}
                                            colClass='col-12 map-location'
                                            value={location}
                                            viewMode='NEW'
                                            validator={this.validator}
                                            validators='not_required'
                                            onChange={this.handleChange}
                                            stateField=''
                                            iconSvg='ico_map_navigate_arrow_blue'
                                            iconSize='stations-map-navigate-arrow'
                                        />
                                        <div className='map-location-embedded-buttons'>
                                            <ActionButton
                                                label={''}
                                                variant='button white button-find'
                                                iconSvg='ico_cards_magnifying_glass'
                                                iconSide='left'
                                                iconSize=''
                                                handleClick={(e) => {
                                                    e.preventDefault();
                                                    if (location && location !== '') {
                                                        this.geocodeAdress();
                                                    }
                                                }}
                                            />
                                            <ActionButton
                                                label={t('list.filter')}
                                                variant='button white button-find'
                                                iconSvg='ico_filter'
                                                iconSide='right'
                                                iconSize=''
                                                handleClick={(e) => {
                                                    e.preventDefault();
                                                    this.setState({dialogVisible: true});
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>                       
                                <LoadScriptNext googleMapsApiKey={googleMapsApiKey}>
                             
                                <GoogleMap
                                    mapContainerStyle={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                    onLoad={this.handleLoad}
                                    center={
                                        geocodeLocation
                                            ? geocodeLocation?.locationCoordinates
                                            : currentCenter
                                            ? currentCenter
                                            : defaultCenter
                                    }
                                    zoom={this.state.zoom}
                                    options={{gestureHandling: 'cooperative', disableDefaultUI: true}}
                                >
                                    {this.state.rerenderFlag && 
                                    <MarkerClusterer
                                        options={{
                                            averageCenter: true,
                                            maxZoom: 18,
                                            styles: this.state.clustersStyle,
                                            enableRetinaIcons: true,
                                            minimumClusterSize : 0
                                        }}
                                        onClick={(a,b,e) => {
                                          }
                                        }
                                        onLoad={clusterer => {this.clustererRef.current = clusterer}}
                                    >
                                        
                                        {(clusterer) =>{
                                            
                                         return   list?.map((marker, index) => {
                                            let position = addedMarkers.filter(pos => pos.locationId === marker.locationId).length >0 ?
                                            addedMarkers.filter(pos => pos.locationId === marker.locationId)[0] : {
                                                    lat: marker?.latitude ? parseFloat(marker?.latitude ) : null,
                                                    lng: marker?.longitude ? parseFloat(marker?.longitude) : null,
                                                    locationId:  marker?.locationId ? marker?.locationId : null,
                                                    mainLocation: null,
                                                };
                                                if (this.state.mapMode.enumValue === 'ELECTRIC') {
                                                    return (
                                                        <Marker
                                                            key={`marker-${position?.locationId}`}
                                                            position= 
                                                            {{
                                                                lat: position.lat,
                                                                lng: position.lng,
                                                            }}
                                                            icon={'/images/ico_moya_logo_green.svg'}
                                                            visible
                                                            onLoad={marker => {
                                                             //   console.log("evInfoWindowRef2")
                                                                this.state.oms.addMarker(marker);
                                                                window.google.maps.event.addListener(
                                                                    marker,
                                                                    "spider_click",
                                                                    e => {
                                                                        this.setState({
                                                                            spiderfierMarkerOpen: true
                                                                        },()=>{
                                                                            if (this.state.spiderfierMarkerOpen) {
                                                                                this.openChargingStationInfoWindow(position.locationId);
                                                                            }
                                                                        });
                                                                    }
                                                                );
                                                            }}
                                                            clusterer={clusterer}
                                                            noClustererRedraw={true}
                                                        >
                                                            {addedMarkers.includes(position) ? null : addedMarkers.push(position)}
                                                            {chargingStationInfoWindowId === position.locationId &&
                                                            chargingStationInfoWindowId !== undefined &&
                                                            this.renderChargingStationMarkerInfo() ? (
                                                                <InfoWindow
                                                                    onLoad={ref => this.state.evInfoWindowRef = ref}
                                                                    key={`info-${position.locationId}`}
                                                                    zIndex={9999}
                                                                    position= {{
                                                                        lat: position.lat,
                                                                        lng: position.lng,
                                                                    }}
                                                                    onCloseClick={() => this.closeChargingStationInfoWindow()}
                                                                >
                                                                    <div>{this.renderChargingStationMarkerInfo()}</div>
                                                                </InfoWindow>
                                                            ) : null}
                                                        </Marker>
                                                    );
                                                } else {
                                                    return (
                                                        <Marker
                                                        key={`marker-${marker?.siteId}`}
                                                            position={{
                                                                lat: marker?.latitude ? parseFloat(marker?.latitude) : null,
                                                                lng: marker?.longitude ? parseFloat(marker?.longitude) : null,
                                                            }}
                                                            icon={
                                                                marker.stationType === 'ATTENDED'
                                                                    ? '/images/ico_moya_logo_blue.svg'
                                                                    : marker.stationType === 'EXPRESS'
                                                                    ? '/images/ico_moya_logo_red.svg'
                                                                    : marker.stationType === 'AUTO_FLEET'
                                                                    ? '/images/ico_moya_logo_black.svg'
                                                                    : undefined
                                                            }
                                                            visible
                                                            onClick={() => {
                                                                this.openInfoWindow(marker.siteId);
                                                            }}
                                                            clusterer={clusterer}
                                                            noClustererRedraw={true}
                                                        >
                                                            {infoWindowId === marker.siteId &&
                                                            infoWindowId !== undefined &&
                                                            this.renderMarkerInfo() ? (
                                                                <InfoWindow
                                                                    key={`info-${marker.siteId}`}
                                                                    zIndex={9999}
                                                                    position={{
                                                                        lat: marker?.latitude ? parseFloat(marker?.latitude) : null,
                                                                        lng: marker?.longitude ? parseFloat(marker?.longitude) : null,
                                                                    }}
                                                                    onCloseClick={() => this.closeInfoWindow()}
                                                                    //   onDomReady={() => mapRef.InfoWindowZ(900)}
                                                                >
                                                                    <div>{this.renderMarkerInfo()}</div>
                                                                </InfoWindow>
                                                            ) : null}
                                                        </Marker>
                                                    );
                                                }
                                            })}
                                        }
                                    </MarkerClusterer> }
                                    
                                    {/* Child components, such as markers, info windows, etc. */}
                                </GoogleMap>
                                
                            </LoadScriptNext>{' '}                            
                            </div>
                        ) : null}
                    </DivContainer>
                </div>
            </div>
        );
    }
}

export default withTranslation()(StationsMapContainer);
